import { BaseService } from '@/core/base-service';

export default class QuestionnaireQuestionService extends BaseService<any> {
  public constructor() {
    super('services/serviceauttech/api/questionnaire-question');
  }
}
